import { FC, useEffect, useState } from 'react';
import './IAThinking.scss';
import IALoader from '../IALoader/IALoader';

interface IAThinkingProps {
  resetKey: number;
  /** Mensagens cicladas; default = etapas de geração da resposta. */
  messages?: string[];
}

const STEP_MESSAGES = [
  "Buscando informações nos artigos da Bevi...",
  "Processando a resposta...",
  "Preparando uma resposta personalizada..."
];

const IAThinking: FC<IAThinkingProps> = ({ resetKey, messages }) => {
  const steps = messages && messages.length > 0 ? messages : STEP_MESSAGES;
  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    setStepIndex(0);
    const timers = [
      setTimeout(() => setStepIndex((i) => Math.min(i + 1, steps.length - 1)), 4000),
      setTimeout(() => setStepIndex((i) => Math.min(i + 1, steps.length - 1)), 8000),
    ];

    return () => timers.forEach(clearTimeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetKey, steps.length]);

  return (
    <div className="IAThinking" data-testid="IAThinking">
      <div className="text-white p-3">
        <div className="d-flex justify-content-center align-items-center gap-2 m-0 h-100">
          <IALoader key={resetKey} />
          <span>{steps[Math.min(stepIndex, steps.length - 1)]}</span>
        </div>
      </div>
    </div>
  );
}

export default IAThinking;
